import { useReducer } from 'react';
import { Sentry } from '@gogame/components';
import { useProcessAsync } from '@gogame/hooks-ts';

import { loadCurrentPermissions, loadCurrentUser } from './sources';
import {
  userReducer,
  defaultUserState,
  SET_USER,
  CLEAN_USER,
  BLOCK_USER,
  SET_PERMISSIONS,
} from './userReducer';

export const useUserManager = () => {
  const [userState, dispatch] = useReducer(userReducer, defaultUserState);
  const [loading, processAsync] = useProcessAsync();
  const getUser = async () => {
    if (loading) {
      // eslint-disable-next-line no-console
      // console.debug(
      //   `[UserManager] Ignore load user and permissions. Because already loading...`
      // );
      return;
    }
    try {
      // eslint-disable-next-line no-console
      // console.debug(`[UserManager] User and permissions loading...`);
      let permissions = await processAsync(loadCurrentPermissions());

      // blockUser();

      dispatch({
        type: SET_PERMISSIONS,
        payload: {
          pages: permissions.pages,
          actions: permissions.actions,
        },
      });

      const user = await processAsync(loadCurrentUser());
      Sentry.setUser({
        id: user?.id,
        username: `${user?.name} (${user?.userPosition})`,
        email: user?.userEmail,
        isTest: user?.isTest,
      });

      dispatch({
        type: SET_USER,
        payload: user,
      });
      // eslint-disable-next-line no-console
      // console.debug(`[UserManager] ...User and permissions loaded`);
    } catch (e) {
      // eslint-disable-next-line no-console
      // console.debug(`[UserManager] ...Api error`);
    }
  };

  const setUser = ({ user, pages, actions }) => {
    dispatch({
      type: SET_USER,
      payload: {
        user: user,
        pages: pages,
        actions: actions,
      },
    });
  };

  const cleanUser = () => {
    dispatch({
      type: CLEAN_USER,
    });
  };

  const blockUser = (user) => {
    dispatch({
      type: BLOCK_USER,
      payload: user,
    });
  };

  return {
    userState,
    loading,
    getUser,
    setUser,
    cleanUser,
    blockUser,
  };
};
